/** Snapshot de posições para setas ▲▼ na tabela de classificação. */

import type { StatusPremioMatematico } from './eliminacaoMatematicaCopa';

export type { StatusPremioMatematico };

export interface LinhaClassificacaoBolao {
  id: string;
  nome: string;
  setor?: string;
  pontos: number;
  posicao: number;
  faltas?: number;
  pagou?: boolean;
  detalheGrupos?: number;
  placarExato?: number;
  resultado1x2?: number;
  mataMata?: number;
  placarExatoMM?: number;
  acertoVencedorMM?: number;
  /** Situação matemática de prêmio (link público / tabela publicada). */
  statusEliminacao?: StatusPremioMatematico;
}

export type VariacaoPosicao = 'subiu' | 'desceu' | 'igual' | 'novo';

export interface DeltaPosicao {
  variacao: VariacaoPosicao;
  /** Posições ganhas (subiu) ou perdidas (desceu). */
  delta: number;
}

function normalizarChave(s: string): string {
  return String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function chaveSnapshotLinha(l: Pick<LinhaClassificacaoBolao, 'id' | 'nome' | 'setor'>): string {
  const id = String(l.id || '').trim();
  if (id && id !== '__meta_bolao__') return id;
  return `${normalizarChave(l.nome)}|${normalizarChave(l.setor || '')}`;
}

export function carregarSnapshotPosicoes(storageKey: string): Record<string, number> {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return {};
    const p = JSON.parse(raw) as { posicoes?: Record<string, number> };
    return p.posicoes && typeof p.posicoes === 'object' ? p.posicoes : {};
  } catch {
    return {};
  }
}

export function calcularDeltasPosicao(
  linhas: LinhaClassificacaoBolao[],
  anterior: Record<string, number>
): Map<string, DeltaPosicao> {
  const out = new Map<string, DeltaPosicao>();
  linhas.forEach((l) => {
    const k = chaveSnapshotLinha(l);
    const ant = anterior[k];
    if (ant == null || !Number.isFinite(ant)) {
      out.set(k, { variacao: 'novo', delta: 0 });
    } else if (ant > l.posicao) {
      out.set(k, { variacao: 'subiu', delta: ant - l.posicao });
    } else if (ant < l.posicao) {
      out.set(k, { variacao: 'desceu', delta: l.posicao - ant });
    } else {
      out.set(k, { variacao: 'igual', delta: 0 });
    }
  });
  return out;
}

export function salvarSnapshotPosicoes(storageKey: string, linhas: LinhaClassificacaoBolao[]): void {
  const posicoes: Record<string, number> = {};
  linhas.forEach((l) => {
    if (l.id === '__meta_bolao__') return;
    posicoes[chaveSnapshotLinha(l)] = l.posicao;
  });
  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify({ posicoes, em: new Date().toISOString() })
    );
  } catch {
    /* quota / privado */
  }
}

export function assinaturaClassificacao(linhas: LinhaClassificacaoBolao[]): string {
  return linhas
    .map((l) => `${chaveSnapshotLinha(l)}:${l.posicao}:${l.pontos}`)
    .join('|');
}
